module.exports = __webpack_public_path__ + "static/media/folding.96840171.svg";